import Link, { LinkProps } from 'next/link';
import React from 'react';

import ChevronLeftIcon from '../../icons/chevron-left.svg';

interface Props extends LinkProps {
  label: string;
}

export const BackLink: React.FC<Props> = (props) => {
  const { href, as, label } = props;

  return (
    <Link href={href} as={as} className="flex p-2 pr-6 rounded text-md font-medium items-center hover:bg-gray-200">
      <ChevronLeftIcon className="h-6 w-6 mr-2" />
      {label}
    </Link>
  );
};
